import { Component, Input, inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import {
  EXPORT_REPORT_ROUTES,
  ExportReportType,
} from "../../../../constants/websocket-event-types.constants";
import { AppNotification } from "../../app-notification.model";

@Component({
  selector: "app-notification-item-export-complete",
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    TranslateModule,
  ],
  templateUrl: "./notification-item-export-complete.component.html",
  styleUrls: ["./notification-item-export-complete.component.scss"],
})
export class NotificationItemExportCompleteComponent {
  private readonly router = inject(Router);

  @Input({ required: true }) notification!: AppNotification;
  @Input({ required: true }) onActivate!: (notificationId: string) => void;
  @Input({ required: true }) onDismiss!: (notificationId: string) => void;

  get jobId(): string {
    return String(this.notification.payload["jobId"] ?? "");
  }

  get reportType(): string {
    return String(this.notification.payload["reportType"] ?? "");
  }

  get messageKey(): string {
    const message = this.notification.payload["message"];
    return typeof message === "string" && message.length > 0
      ? message
      : "report_ready";
  }

  onItemClick(): void {
    const route = EXPORT_REPORT_ROUTES[this.reportType as ExportReportType];
    if (!route) {
      return;
    }

    void this.router
      .navigate([route], { queryParams: { notifyJobId: this.jobId } })
      .then(() => this.onActivate(this.notification.id))
      .catch((error) => {
        console.error("Error handling export notification click:", error);
        this.onActivate(this.notification.id);
      });
  }

  onDelete(event: Event): void {
    event.stopPropagation();
    this.onDismiss(this.notification.id);
  }
}
